import { ProjectChatsTab } from "@/components/projects/project-chats-tab.tsx";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_authenticated/dashboard/projects/$projectId/chats",
)({
	component: ProjectChatsTab,
});
